import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';

import './style.sass';

import userAvatarPlaceholder from 'assets/img/icons/user-icon.svg';
import { useBreakpointType } from 'app/services/breakpoints';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { Modal } from '../common/Modal';
import { UserSettings } from '../UserSettings';
import { AppViewModel } from 'app/viewModels';
import { UserViewModel } from 'app/viewModels/components/UserViewModel';
import { AppController } from 'app/controllers';

export const UserProfile = observer(() => {
    const { name, userId } = useModelWithArguments(UserViewModel, AppController.Instance.Auth.user.id);

    const { isMobile } = useBreakpointType();
    const [isModalActive, setIsModalActive] = useState<boolean>(false);

    const handleOpenModal = () => {
        AppViewModel.Instance.isMenuOpened.setFalse();
        setIsModalActive(true);
    };

    const handleCloseModal = () => {
        setIsModalActive(false);
    };

    return (
        <div className="user-profile">
            {!isMobile &&
                (name
                    ? <span className="user-profile__greetings p1-medium grey-1">
                        Hello, <span className="violet-text">{name}</span>
                    </span>
                    : <span className="user-profile__greetings p1-medium grey-1">Hello!</span>
                )
            }

            <div className="user-profile__avatar" onClick={handleOpenModal}>
                <img src={userAvatarPlaceholder} className="user-profile__icon"/>
            </div>

            {isModalActive &&
                createPortal(
                    <Modal onClose={handleCloseModal}>
                        <UserSettings
                            userId={userId}
                            onClickCloseBtn={handleCloseModal}
                        />
                    </Modal>,
                    document.body,
                ) as React.ReactNode
            }
        </div>
    );
});
